module.exports = __webpack_public_path__ + "img/whats-new-21_en.55915b4.jpg";